/**
 * ATOM LED -- Hero Slider (vanilla JS)
 * Dot pagination with deferred hydration for offscreen slide images.
 * ~60 lines. No dependencies.
 */
(function () {
  'use strict';

  var INTERVAL = 6500;
  var hero = document.querySelector('.xp-hero--slider');
  if (!hero) return;

  var slides = hero.querySelectorAll('.xp-hero__slide');
  var dots = hero.querySelectorAll('.xp-hero__dot');
  var current = 0;
  var paused = false;
  var timer;

  function hydrateSlide(index) {
    var slide = slides[index];
    if (!slide) return;

    var img = slide.querySelector('img[data-atom-hero-deferred]');
    if (!img) return;

    var sizes = img.getAttribute('data-sizes');
    var srcset = img.getAttribute('data-srcset');
    var src = img.getAttribute('data-src');

    if (sizes) img.setAttribute('sizes', sizes);
    if (srcset) img.setAttribute('srcset', srcset);
    if (src) img.setAttribute('src', src);

    img.removeAttribute('data-sizes');
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
    img.removeAttribute('data-atom-hero-deferred');
  }

  function goTo(index) {
    slides[current].classList.remove('is-active');
    dots[current].classList.remove('is-active');
    dots[current].setAttribute('aria-selected', 'false');

    current = (index + slides.length) % slides.length;
    hydrateSlide(current);

    slides[current].classList.add('is-active');
    dots[current].classList.add('is-active');
    dots[current].setAttribute('aria-selected', 'true');
  }

  function next() {
    goTo(current + 1);
  }

  function startAutoplay() {
    stopAutoplay();
    timer = setInterval(function () {
      if (!paused) next();
    }, INTERVAL);
  }

  function stopAutoplay() {
    if (timer) clearInterval(timer);
  }

  // Pause on hover
  hero.addEventListener('mouseenter', function () { paused = true; });
  hero.addEventListener('mouseleave', function () { paused = false; });

  // Dot clicks
  dots.forEach(function (dot, i) {
    dot.addEventListener('pointerenter', function () { hydrateSlide(i); });
    dot.addEventListener('focus', function () { hydrateSlide(i); });
    dot.addEventListener('touchstart', function () { hydrateSlide(i); }, { passive: true });
    dot.addEventListener('click', function () {
      goTo(i);
      startAutoplay(); // reset timer on manual nav
    });
  });

  // Reduced motion: no autoplay
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  // Round 9 v7 — autoplay completely DISABLED on initial page load (2026-05-14).
  // Diagnostic step: Round 9 v6 (30s autoplay delay) still showed Desktop CLS 0.326 on PSI.
  // To prove whether the autoplay slide transition is the cause, v7 removes autoplay entirely.
  // Manual dot navigation still works. If Desktop CLS stays at 0.326, the cause is NOT
  // the slider transition — must be investigated elsewhere.
})();
